<template>
  <div class="flex-box pl5 pr5 mb10 al-c" :style="compWidth()">
    <div class="tx-r" :style="{ 'width': this.width ? this.width + 'em' : 'auto' }">{{ typeData.label }}：</div>
    <div class="flex-1">
      <el-select class="w100" multiple collapse-tags v-model="value" :placeholder="typeData.placeholder ? typeData.placeholder : '请选择' + typeData.label">
        <el-option v-for="(item, index) in typeData.data" :key="index" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectComp",
  props: ["type-data", "width", "colspan"],
  components: {},
  data() {
    return {
      value: [],
    };
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {
    compWidth() {
      if (this.colspan) {
        if (typeof this.colspan == "number") {
          return { width: this.colspan + "px" };
        } else {
          return { width: this.colspan };
        }
      } else {
        return { width: "33%" };
      }
    },
  },
  watch: {},
};
</script>
